import { Common } from '@stockbit/ui';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { renderStockSuggestions } from './options';
import { Autocomplete } from './styled';
import { Relative } from '../../OnBoardingLayout/styled';

// Store company
import Company, {
  effects as companyEffects,
  selectors as companySelectors,
} from 'lib/entities/company';

const { Input, Iconmoon, Text } = Common;

function Search() {
  const [timeInterval, setTimeInterval] = useState(0);
  const [keyword, setKeyword] = useState("");
  const {
    search: { data: dataSearch },
  } = useSelector(companySelectors);

  // handle actions
  const dispatch = useDispatch();

  const handleSearchCompany = (val) => {
    if (val.length > 1) {
      if (timeInterval) {
        clearTimeout(timeInterval);
      }

      setTimeInterval(
        setTimeout(() => {
          dispatch(companyEffects.getSearchCompany(val));
        }, 1500),
      );
    }
  };

  const handleSelectCompany = (val) => {
    // dispatch search company with stock name
    dispatch(companyEffects.getSearchCompany(val));
  };

  const handleClearSearch = () => {
    setKeyword("");
    dispatch(Company.actions.clearSearch());
  };

  const options = renderStockSuggestions(dataSearch);

  return (
    <Relative>
      <Autocomplete
        options={options}
        width="100%"
        value={keyword}
        onChange={setKeyword}
        onSelect={handleSelectCompany}
        onSearch={handleSearchCompany}
        mb="8px"
        getPopupContainer={(trigger) => trigger.parentElement}
      >
        <Input
          prefix={<Iconmoon className="icon-avatar_search" />}
          placeholder="Type here to add companies..."
          height="36px"
          width="100%"
        />
      </Autocomplete>
      {options.length > 0 && (
        <Text
          align="center"
          style={{ fontStyle: 'italic', cursor: 'pointer' }}
          onClick={handleClearSearch}
        >
          Clear result
        </Text>
      )}
    </Relative>
  );
}

export default Search;
